<template>
  <div class="leftBlock">
    <div class="content">
      <div class="modularOne">
        <div class="title">
          <span>专利转化价值分布</span>
          <img src="../../../../../static/img/21.png" alt="">
        </div>
        <div class="contentBlock contentBlockOne">
          <div class="row" v-for="(item, index) in rangeList" :key="item.name" @click="detailClick(item)">
            <div class="imgClass">
              <div :class="imgCount(index)"></div>
              <span class="name">{{ item.name }}</span>
            </div>
            <div class="number"><span class="one">{{ item.count }}</span>件（{{ item.per }}）</div>
          </div>
        </div>
        <div class="title">
          <span>专利运营转化</span>
          <img src="../../../../../static/img/21.png" alt="">
        </div>
        <div class="contentBlock">
          <Pie :options="options" class="echartsBlock" @echartClick="echartClick"></Pie>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pie from '@/components/echarts/Pie'
import {
  getValueRange,
  getTransferRange,
  getWorthRange,
  isClassify
} from '@/api/databaseBin'
import BaseMixin from '@/views/_mixin'
export default {
  mixins: [BaseMixin],
  data() {
    return {
      options: {},
      rangeList: [],
      transferList: [],
      total: 0,
      rangeMap: {
        核心专利: 1,
        重要专利: 2,
        一般专利: 3,
        潜力专利: 4,
        沉默专利: 5
      },
      noClassify: {
        核心专利: '价值度区间=("10" or "9")',
        重要专利: '价值度区间=("8" or "7")',
        一般专利: '价值度区间=("4" or "3")',
        潜力专利: '价值度区间=("6" or "5")',
        沉默专利: '价值度区间=("2" or "1")'
      }
    }
  },
  components: {
    Pie
  },
  computed: {},
  async mounted() {
    await this.getPatent()

    this.valueRange()
    this.transferRange()
    // this.pieCharts()
  },
  methods: {
    async getPatent() {
      const res = await getWorthRange()
      if (res.code === 200) {
        const worthRange = res.data
        this.rangeMap = {}
        if (worthRange && worthRange.length > 0) {
          worthRange.forEach((item) => {
            this.rangeMap[item.levelName] = item.levelNo
          })
        }
      }
    },
    echartClick(params) {
      this.jumpIpi('法律事件=' + params.data.type, 'isMerge', 'publicOrder')
    },
    async detailClick(item) {
      const res = await isClassify()
      let expression = ''
      if (res.data) {
        expression = 'worth_level_stat=' + this.rangeMap[item.name]
        this.jumpIpi(`${expression} and 专利状态=有效`)
      } else {
        expression = this.noClassify[item.name]
        this.jumpIpi(`${expression}`, 'isMerge', 'publicOrder')
      }
      // this.jumpIpi(`${expression} and 专利状态=有效`)
    },
    imgCount(val) {
      switch (val) {
        case 0:
          return 'imgOne'
        case 1:
          return 'imgTwo'
        case 2:
          return 'imgThree'
        case 3:
          return 'imgFour'
        case 4:
          return 'imgFive'
      }
    },
    transferRange() {
      getTransferRange().then((res) => {
        if (res[this.codeMapping]) {
          const list = [
            {
              label: '许可',
              value: 'permit',
              colorStops: [
                {
                  offset: 0,
                  color: '#A658FD' // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: '#3CF2F6' // 100% 处的颜色
                }
              ]
            },
            {
              label: '质押',
              value: 'pledege',
              colorStops: [
                {
                  offset: 0,
                  color: '#A45FFE' // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: '#7D96F8' // 100% 处的颜色
                }
              ]
            },
            {
              label: '转让',
              value: 'transfer',
              colorStops: [
                {
                  offset: 0,
                  color: '#38EFF0' // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: '#779BF8' // 100% 处的颜色
                }
              ]
            }
          ]
          this.transferList = res[this.dataMapping]
          this.transferList.forEach((item) => {
            list.forEach((ele) => {
              if (item.name === ele.value) {
                item.name = '专利' + ele.label + '/件数' + item.count
                item.value = item.count
                item.type = ele.label
                item.itemStyle = {
                  borderColor: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 1,
                    colorStops: ele.colorStops,
                    global: false // 缺省为 false
                  }
                }
              }
            })
            this.total += item.count
          })
          this.pieCharts()
        }
      })
    },
    valueRange() {
      getValueRange().then((res) => {
        if (res[this.codeMapping]) {
          this.rangeList = res[this.dataMapping]
        }
      })
    },
    pieCharts() {
      const dataList = this.transferList
      // const colorList = ['#4D88FE', '#50CCCB', '#FFBF3C']
      const gradList = [
        new this.$echarts.graphic.LinearGradient(0, 0, 1, 1, [
          {
            offset: 0,
            color: '#38EFF0'
          },
          {
            offset: 1,
            color: '#779BF8'
          }
        ]),
        new this.$echarts.graphic.LinearGradient(0, 1, 1, 1, [
          {
            offset: 0,
            color: '#A45FFE'
          },
          {
            offset: 1,
            color: '#7D96F8'
          }
        ]),
        new this.$echarts.graphic.LinearGradient(0, 1, 1, 1, [
          {
            offset: 0,
            color: '#A658FD'
          },
          {
            offset: 1,
            color: '#3CF2F6'
          }
        ])
      ] // 动态渐变颜色
      this.options = {
        tooltip: {
          trigger: 'item',
          formatter(params) {
            const name = params.data.name.replace(/\d+/gi, '')
            return (
              params.marker +
              ' ' +
              `${name}&nbsp;&nbsp;&nbsp;&nbsp;<b>` +
              params.value +
              '</b>'
            )
          }
        },
        title: {
          text: '专利运用',
          subtext: this.total, // 小标题
          left: '24%',
          top: '38%',
          textAlign: 'center',
          textStyle: {
            color: '#ffffff',
            fontSize: '16'
          },
          subtextStyle: {
            color: '#ffffff',
            fontSize: '20'
          }
        },
        legend: {
          icon: 'roundRect',
          data: dataList.map((item) => item.name),
          right: '18%',
          top: '20%',
          orient: 'vertical',
          itemWidth: 1, // 设置宽度
          itemHeight: 42, // 设置高度
          textStyle: {
            fontSize: 17,
            color: '#fff',
            width: 150,
            overflow: 'break'
          }
        },
        zlevel: 999,
        series: [
          {
            // 外圈
            name: '',
            type: 'pie',
            radius: ['70%', '80%'],
            center: ['30%', '50%'],
            itemStyle: {
              normal: {
                borderColor: '#364684',
                borderWidth: 1,
                color: function (params) {
                  return gradList[params.dataIndex]
                },
                labelLine: {
                  width: 1,
                  length: 10,
                  length2: 30
                },
                label: {
                  color: '#ddd',
                  position: 'outside',
                  fontSize: 12,
                  padding: [0, -20, -20, -10],
                  overflow: 'none',
                  formatter: function (params) {
                    if (params.name !== '') {
                      return params.data.per
                    } else {
                      return ''
                    }
                  }
                }
              }
            },
            data: dataList,
            left: '-8%'
          },
          {
            // 内圈
            type: 'pie',
            radius: ['60%', '70%'],
            center: ['30%', '50%'],
            silent: true,
            itemStyle: {
              normal: {
                borderColor: '#364684',
                borderWidth: 1,
                color: '#26B1CB',
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            },
            data: dataList,
            left: '-8%'
          },
          {
            // 内圈
            type: 'pie',
            radius: ['50%', '60%'],
            center: ['30%', '50%'],
            silent: true,
            itemStyle: {
              normal: {
                borderColor: '#364684',
                borderWidth: 1,
                color: '#1A82A0',
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            },
            data: dataList,
            left: '-8%'
          }
        ]
      }
    }
  }
}
</script>
